export default __webpack_public_path__ + "static/media/pantalla1.07016578.png";